var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTextarea',{attrs:{"label":_vm.label,"value":_vm.value,"required":_vm.required,"disabled":_vm.disabled,"persistent-hint":!!_vm.info,"hint":_vm.info,"auto-grow":"","rules":_vm.required ? _vm.isRequired : []},on:{"input":function($event){return _vm.$emit('change', {val: $event, name: _vm.name})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }